import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import useSignupStore from "../../../store/SignUpStore";
import { toast } from "../../../utils/toast";

// 회원가입 1/3 — 약관 동의. SOFTCAT 디자인 시스템 이식본.
const TERMS = [
    { key: "service", label: "서비스 이용약관 동의", note: "필수", path: "/term-of-use" },
    { key: "privacy", label: "개인 정보 수집 및 이용 동의", note: "필수", path: "/privacy-policy" },
    { key: "marketing", label: "마케팅 알림 수신 동의", note: "선택", path: null },
];

const ConsentPage = () => {
    const { setMarketingOptIn } = useSignupStore();
    const navigate = useNavigate();
    const [consents, setConsents] = useState({
        all: false,
        service: false,
        privacy: false,
        marketing: false,
    });

    const handleAllConsent = (checked) => {
        setConsents({ all: checked, service: checked, privacy: checked, marketing: checked });
    };

    const handleSingleConsent = (name, checked) => {
        const next = { ...consents, [name]: checked };
        const allChecked = ["service", "privacy", "marketing"].every((k) => next[k]);
        setConsents({ ...next, all: allChecked });
    };

    const isAllRequiredChecked = () => consents.service && consents.privacy;

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!isAllRequiredChecked()) {
            toast("필수 약관에 모두 동의해주세요.");
            return;
        }
        setMarketingOptIn(consents.marketing);
        navigate("/signup/account-info");
    };

    return (
        <div className="sch-awrap sch-awrap--wide">
            <div className="sch-no">JOIN — 1분이면 끝나요</div>
            <h1>회원가입</h1>

            <form onSubmit={handleSubmit} className="sch-aform">
                <div className="sch-fsec" style={{ borderTop: 0, paddingTop: 0, marginTop: 0 }}>
                    <span className="sch-t">01 — 약관 동의</span>

                    <div className="sch-agree">
                        <label>
                            <input
                                type="checkbox"
                                className="sc-check"
                                checked={consents.all}
                                onChange={(e) => handleAllConsent(e.target.checked)}
                            />
                            약관 전체동의
                        </label>

                        {TERMS.map(({ key, label, note, path }) => (
                            <label key={key}>
                                <input
                                    type="checkbox"
                                    className="sc-check ag"
                                    checked={consents[key]}
                                    onChange={(e) => handleSingleConsent(key, e.target.checked)}
                                />
                                {label}
                                <span className="sch-mut">
                                    {note}
                                    {path && (
                                        <>
                                            {" · "}
                                            <button
                                                type="button"
                                                className="sch-inlinelink"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    window.open(path, "_blank", "noopener");
                                                }}
                                            >
                                                보기
                                            </button>
                                        </>
                                    )}
                                </span>
                            </label>
                        ))}
                    </div>
                </div>

                {!isAllRequiredChecked() && (
                    <div className="sc-alert sc-alert--warning">
                        필수 약관(서비스 이용약관, 개인정보 수집 및 이용)에 동의해야 다음 단계로 넘어갈 수 있습니다.
                    </div>
                )}

                <button
                    type="submit"
                    className="sch-bigbtn"
                    style={{ justifyContent: "center", marginTop: "6px" }}
                    disabled={!isAllRequiredChecked()}
                >
                    다음
                </button>

                <div className="sch-alinks">
                    이미 계정이 있나요?&nbsp;
                    <button
                        type="button"
                        className="sch-inlinelink"
                        onClick={() => navigate("/login")}
                    >
                        로그인
                    </button>
                </div>
            </form>
        </div>
    );
};

export default ConsentPage;
